import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { AnatomicalSideEnum, BoneTypeEnum, LanguageService } from '../../../core';
import { ViewService } from '../../services';


/**
* Base component to share common features in every component.
*/
@Component({
	selector: 'vw-base',
	template: ``,
	imports: [],
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class VwBaseComponent {

	protected readonly srv = inject(ViewService);
	protected readonly langSrv = inject(LanguageService);

	labels = computed(() => this.langSrv.labels());

	sideEnum = AnatomicalSideEnum;

	// PLAN
	isLeft = computed(() => this.srv.plan()?.side === AnatomicalSideEnum.Left);
	isRight = computed(() => this.srv.plan()?.side === AnatomicalSideEnum.Right);

	isFemur = computed(() => this.srv.plan()?.boneType === BoneTypeEnum.Femur);
	isTibia = computed(() => this.srv.plan()?.boneType === BoneTypeEnum.Tibia);
	isLongLeg = computed(() => this.srv.plan()?.boneType === BoneTypeEnum.LongLeg);

	hasAP = computed(() => !!this.srv.plan()?.apImageGuid);
	hasLT = computed(() => !!this.srv.plan()?.ltImageGuid);

}
